import { render, staticRenderFns } from "./RevenueCenterEdit.vue?vue&type=template&id=22d11e44&scoped=true"
import script from "./RevenueCenterEdit.vue?vue&type=script&lang=js"
export * from "./RevenueCenterEdit.vue?vue&type=script&lang=js"
import style0 from "./RevenueCenterEdit.vue?vue&type=style&index=0&id=22d11e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d11e44",
  null
  
)

export default component.exports